import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';

export enum TextFieldStyle {
  Default = 'Default',
  Info = 'Info',
  Bold = 'Bold',
  Component = 'Component',
  Datetime = 'Datetime',
  Success = 'Success',
  Warning = 'Warning',
  Error = 'Error'
}

export enum TextFieldSize {
  Default = 'default',
  Small = 'small',
  Large = 'large'
}

@Component({
  selector: 'pcs-text-field',
  templateUrl: './text-field.component.html',
  styleUrls: ['./text-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextFieldComponent implements OnChanges {
  @Input() textFieldValue = '';
  @Input() textFieldStyle = TextFieldStyle.Default;
  @Input() textFieldSize = TextFieldSize.Default;
  @Input() showTooltipForValue = false;
  @Input() tooltipContainer = '';

  textFieldClasses = null;

  @HostBinding('class.small-text-field')
  private get isSmall() {
    return this.textFieldSize === TextFieldSize.Small;
  }

  @HostBinding('class.show-tooltip-for-value')
  private get isTooltipForValue() {
    return this.showTooltipForValue;
  }

  ngOnChanges({textFieldStyle, textFieldSize}: SimpleChanges): void {
    if (textFieldStyle || textFieldSize) {
      this.textFieldClasses = this.calculateTextFieldClasses();
    }
  }

  private calculateTextFieldClasses() {
    return {
      '': this.isDefault(),
      'text-muted': this.isInfo(),
      'fw-bold': this.isBold(),
      'component-color': this.isComponent(),
      datetime: this.isDatetime(),
      'form-control-sm': this.isSmall,
      'form-control-lg': this.isLarge(),
      'alert-success': this.isSuccess(),
      'alert-warning': this.isWarning(),
      'alert-danger': this.isError()
    };
  }

  private isDefault() {
    return this.textFieldStyle === TextFieldStyle.Default;
  }

  private isInfo() {
    return this.textFieldStyle === TextFieldStyle.Info;
  }

  private isBold() {
    return this.textFieldStyle === TextFieldStyle.Bold;
  }

  private isComponent() {
    return this.textFieldStyle === TextFieldStyle.Component;
  }

  private isDatetime() {
    return this.textFieldStyle === TextFieldStyle.Datetime;
  }

  private isSuccess() {
    return this.textFieldStyle === TextFieldStyle.Success;
  }

  private isWarning() {
    return this.textFieldStyle === TextFieldStyle.Warning;
  }

  private isError() {
    return this.textFieldStyle === TextFieldStyle.Error;
  }

  private isLarge() {
    return this.textFieldSize === TextFieldSize.Large;
  }
}
